"use client"

/* eslint-disable @typescript-eslint/no-explicit-any */
import { getUserInfo } from "@/services/userService"
import Documents from "./Documents"


export default function MyDocuments() {
  const userInfo:any = getUserInfo();
  const userId = userInfo?(userInfo.id?userInfo.id:null):null;
  return (<Documents key={'myDocuments'} userId={userId} />)
}
